// Product Finder translations

const productFinder = {
  en: {
    productFinder: {
      title: "Product Finder",
      subtitle: "Answer a few questions and we'll show you the right product — no AI, just logic.",
      stepOf: "Step",
      of: "of",
      startOver: "Start over",
      back: "Back",
      recommendation: "Your recommendation",
      topPicks: "Your top picks",
      match: "matches",
      matchSingle: "match",
      bestMatch: "Best match",
      viewProduct: "View Product",
      notSureTitle: "Not what you were looking for?",
      notSureDesc: "Our support team helps you choose the right product for your specific use case.",
      contactSupport: "Contact Support",
    },
  },

  de: {
    productFinder: {
      title: "Produkt-Finder",
      subtitle: "Beantworte ein paar Fragen und wir zeigen dir das richtige Produkt – ohne KI, nur Logik.",
      stepOf: "Schritt",
      of: "von",
      startOver: "Neu starten",
      back: "Zurück",
      recommendation: "Deine Empfehlung",
      topPicks: "Deine Top-Empfehlungen",
      match: "Treffer",
      matchSingle: "Treffer",
      bestMatch: "Beste Wahl",
      viewProduct: "Produkt ansehen",
      notSureTitle: "Nicht das Richtige dabei?",
      notSureDesc: "Unser Support-Team hilft dir bei der Auswahl des richtigen Produkts für deinen Anwendungsfall.",
      contactSupport: "Support kontaktieren",
    },
  },
};

export default productFinder;
